export { default } from './Ticks';
